import * as yup from "yup";
export const OnboardhydrobuildSchema = yup.object().shape({
  UID: yup.string().required("Required"),
  Watertankcapacity: yup.number().required("Required"),
  // FertiliserSolutiontype: yup.string().required("Required"),
  FertilisersolutionPPM: yup.string().required("Required"),
  cropId: yup.number().required("Required"),
  // Croptype: yup.string().required("Required"),
});
